import { startCheckout } from "@/lib/billing";
import { PLAN_ORDER } from "@/lib/plans";
import { AgentLayout } from "@/components/agent/AgentLayout";
import { PlanCards } from "@/components/shared/PlanCards";
import { EmptyState, Loading, PageHeader, PrimaryButton, SecondaryButton } from "@/components/agent/ui";
import { useBilling } from "@/pages/Billing";

export default function BillingPlans() {
  const { billing, error, load } = useBilling();

  const action = (plan, isCurrent) => {
    if (isCurrent) return <SecondaryButton size="default" disabled className="w-full" testid={`plan-cta-${plan.id}`}>Your current plan</SecondaryButton>;
    const upgrade = PLAN_ORDER.indexOf(plan.id) > PLAN_ORDER.indexOf(billing.plan);
    const Btn = upgrade ? PrimaryButton : SecondaryButton;
    return (
      <Btn size="default" className="w-full" disabled={!billing.can_change} onClick={() => startCheckout(plan.id)} testid={`plan-cta-${plan.id}`}>
        {upgrade ? `Upgrade to ${plan.name}` : `Switch to ${plan.name}`}
      </Btn>
    );
  };

  let body;
  if (error) body = <EmptyState title="Couldn't load plans" text={error} action={<SecondaryButton onClick={load} testid="plans-retry">Try again</SecondaryButton>} testid="plans-error" />;
  else if (!billing) body = <Loading testid="plans-loading" />;
  else body = (
    <>
      <PlanCards current={billing.plan} action={action} testid="billing-plans" />
      {!billing.can_change && <p className="text-sm text-muted-foreground" data-testid="plans-owner-only">Only an owner or admin can change the plan.</p>}
    </>
  );

  return (
    <AgentLayout wide>
      <PageHeader back={{ to: "/billing", label: "Billing" }} title="Plans" description="Change plan at any time. Unused screenings roll over for 1 month on Starter and Pro." />
      {body}
    </AgentLayout>
  );
}
